import React from "react";
import { translate } from "../../../../../../../../common/providers";
import styles from "./AddRedressInformation.module.css";

const AddRedressInformation = () => (
	<div className={styles.container}>{translate("smart-review.redress-add.header.information")}</div>
);
export default AddRedressInformation;
